import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
    private _localStorage: Storage;

    constructor() {
        this._localStorage = this.getLocalStorage();
    }

    getLocalStorage(): Storage {
        return localStorage;
    }

    setInfo(key: string, data: string): void {
        this._localStorage.setItem(key, data);
    }

    loadInfo(key: string): string {
        const data = this._localStorage.getItem(key);
        return data;
    }

    clearInfo(key: string) {
        this._localStorage.removeItem(key);
    }

    clearAllLocalStorage(): void {
        this._localStorage.clear();
    }

    clearAllUserStorage(): void {
        this._localStorage.removeItem('id_token');
        this._localStorage.removeItem('access_token');
        this._localStorage.removeItem('token');
        this._localStorage.removeItem('refresh_token');
        this._localStorage.removeItem('subscriptions');
        this._localStorage.removeItem('enterprise');
    }
}
